var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"main-box"},[_c('h2',[_vm._v("欢迎访问迈迪讯承包商HSE培训平台后台管理系统")])])
}]

export { render, staticRenderFns }